import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'Ticket',
    format: 'Format',
    side: 'Side',
    sideCt: 'Counter-Terrorists',
    sideT: 'Terrorists',
    sideAny: 'Any',
    skinLabel: 'Skin',
    practiceBots: 'Vs bots',
    playWithBots: 'Play with bots · free',
    winRangeTitle: 'Skin for a win',
    skip: 'Skip',
    // How to play (rules sheet + first-run slides)
    howtoTitle: 'How to play',
    howtoNext: 'Next',
    howtoStart: 'Got it, let’s play',
    howtoSkip: 'Skip',
    howtoSlide1Title: 'Turn-based PvP',
    howtoSlide1Text:
      'The ticket is your entry. Opponents are real players with the same ticket. The winning team splits the bank.',
    howtoSlide2Title: 'The buy doesn’t decide',
    howtoSlide2Text:
      'Everyone gets the same budget. Weapons set the style: the AWP is a rare heavy shot, the machine gun fires often and steady.',
    howtoSlide3Title: 'Read your opponent',
    howtoSlide3Text:
      'Each round you pick a stance. Watch what your opponent did last round — and counter it.',
    howtoSlide4Title: 'A skin split by contribution',
    howtoSlide4Text:
      'The bank is split by damage and utility, then paid out as a skin worth your share. Even if you die, your contribution counts. The bank fills from every ticket’s spin — a win pays out a skin worth at least your entry +50%, the ceiling is ×5.',
    howtoTryBots: 'Try it free first — vs bots',
    howtoLoopTitle: 'How a match goes',
    howtoLoopStep1: 'Pick a ticket, a side and a format — that’s your entry.',
    howtoLoopStep2: 'Buy phase: weapon, armor and utility on an equal budget.',
    howtoLoopStep3: 'Turn-based fight: every round — a stance or an action. Pick your target with a tap.',
    howtoLoopStep4: 'The match bank is split among the winners by contribution and paid out as a skin.',
    howtoStancesTitle: 'Stances',
    howtoRpsCaption: 'The arrow shows who beats whom',
    howtoStancesText:
      '[[defense|Defense]] reflects part of the damage, [[maneuver|Dodge]] lowers the enemy’s accuracy, [[attack|Attack]] boosts your fire.',
    howtoWeaponsTitle: 'Weapons',
    howtoWeaponAwp: 'AWP — all or nothing: rare shot, huge crit.',
    howtoWeaponRifle: 'Rifle — the balanced classic.',
    howtoWeaponLmg: 'Machine gun — often and steady, no crit swings.',
    howtoUtilityTitle: 'Utility',
    howtoSmokeTargetNote: 'Smoke covers an ally — tap a teammate to pick who it shields.',
    howtoUtilTeamNote: 'Smoke and flash exist only in team modes.',
    howtoMoneyTitle: 'Money',
    howtoMoney1: 'The buy budget is equal for everyone — it sets the style, not the power.',
    howtoMoney2: 'The prize is a skin split by contribution: damage + utility. Dying doesn’t erase it.',
    howtoMoney3: 'The bank fills from every ticket’s spin: a win pays out a skin worth at least your entry +50%, the ceiling is ×5.',
    howtoMoney4: 'Every ticket is one bank spin — from half up to 2.5× the ticket per spin. Pricier ticket — bigger bank.',
    history: 'History',
    partyJoin: 'Join by code',
    partyJoinPlaceholder: 'Party code',
    partyJoinAction: 'Join',
    partyShare: 'Invite friends',
    partyKick: 'Remove from party',
    partyShareText: 'Join my SHOT party — code {{code}}',
    partyErrNotFound: 'Party not found — check the code.',
    partyErrInGame: 'That party is already in a game — finish it first.',
    partyErrFull: 'That party is full.',
    partyErrInMatch: 'Finish your active match first.',
    multiaccErr: 'You cannot join here.',
    maintenanceErr: 'The game is updating — check back in a couple of minutes.',
    balanceErr: 'Not enough coins for the entry — top up your balance and come back.',
    topUpBalance: 'Top up balance',
    maintenanceBanner: 'The game is updating — matches reopen in a couple of minutes.',
    updateBanner: 'A new version is out — update to keep playing.',
    updateNow: 'Update',
    comingSoonBadge: 'Coming soon',
    comingSoonHint: 'The mode hasn’t opened yet — stay tuned.',
    partyLeaderTag: 'leader',
    partyLeave: 'Leave party',
    partyCodeLabel: 'Party code',
    partyCopy: 'Copy',
    partyCopied: 'Copied',
    partyCreatedBy: 'Created by {{name}}',
    partyLeaderBadge: 'Leader',
    partyReadyYes: 'Ready',
    partyReadyNo: 'Not ready',
    partyWaitingOthers: 'Waiting for the other players',
    partyConfirmReady: 'Confirm you are ready to start.',
    partyImReady: 'I am ready',
    partyYou: 'You',
    partyShareBtn: 'Share',
    partyReadyCount: 'Ready: {{n}} of {{m}}',
    // Modes
    mode1: '1 v 1',
    mode2: '2 v 2',
    mode5: '5 v 5',
    modeN: '{{size}} v {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: 'Games',
    introCard: 'Rush Mid is a Counter-Strike-style take on case battles: players enter a match with a fixed ticket, fight each other, and a win pays out a skin worth a share tied to the entry price.',
    openGamesTitle: 'Open games',
    howToPlayLink: 'how to play',
    winUpToPrefix: 'for a win up to',
    winUpToSuffix: '',
    waitingForPlayer: 'waiting for a player…',
    winRangeChip: 'a win pays',
    notEnoughShort: 'missing',
    homeAllGames: 'all games',
    createGame: 'Create game · ',
    createGameShort: 'Create game',
    gamesEmptyTitle: 'Nothing here yet',
    gamesEmpty: 'No open games yet — create the first one',
    gamesBack: 'Back to games',
    openGameTitle: 'Game',
    joinSide: 'Sit',
    confirmSitTitle: 'Join the game',
    confirmSitMessage: 'Sit in for {{amount}}?',
    confirmSitYes: 'Sit',
    gameFull: 'All seats are taken',
    partyBadge: 'party ×{{k}}',
    tabFighter: 'Fighter',
    squadTitle: 'Party',
    inviteFriends: 'Invite friends',
    leaderPicking: 'The leader is picking a game…',
    partyWontFit: 'party ×{{k}} won’t fit',
    graceLockedBadge: 'newcomer game · {{s}}s',
    graceLockedHint: 'A newcomer is warming up here. The lobby opens to everyone in {{s}}s.',
    partyFits: 'party ×{{k}} fits',
    wontFit: 'won’t fit',
    memberBadge: 'In a party ×{{k}}',
    createSheetTitle: 'Create game',
    createSheetSubtitle: 'Pick a ticket, format and side',
    botFillIn: 'Bots fill in {{s}}s',
    leaveGame: 'Leave',
    youLabel: 'you',
    gameInvite: 'Invite',
    gameShareText: 'Come join my Rush Mid game',
    gameShareButton: 'Play',
    replayTitle: 'Match replay',
    shareReplay: 'Share replay',
    replayShareText: 'Check out this Rush Mid match',
    replayShareButton: 'Watch replay',
    gameGone: 'This game has already started or closed',
    tipLabel: 'Tip',
    preparing: 'Preparing the battle…',
    loadingGame: 'Loading battle…',
    loading: 'Loading…',
    errorTitle: 'RushMid error',
    backToLobby: 'Back to games',
    reloadScreen: 'Reload screen',
    // Buy
    buyTitle: 'Buy',
    remaining: 'Remaining',
    yourFighter: 'Your fighter',
    hp: 'HP',
    armorShort: 'armor',
    weapon: 'Weapon',
    armor: 'Armor',
    grenade: 'Grenade',
    grenadeTaken: 'Taken',
    medkit: 'Medkit',
    accuracy: 'Accuracy',
    stance: 'Stance',
    stanceCenter: 'Centre',
    stanceAttack: 'Attack',
    stanceDefense: 'Defense',
    stanceManeuver: 'Dodge',
    knife: 'Knife',
    smoke: 'Smoke',
    flash: 'Flash',
    nadeSmoke: 'Smoke',
    nadeFrag: 'Frag',
    logSmoke: 'smoke',
    logAdrenaline: 'adrenaline',
    adrenaline: 'adrenaline',
    // AFK guard — a clamped player's canvas/scoreboard mark + the missed-round heads-up
    afkBadge: 'AFK',
    afkWarn: 'Miss one more round and you forfeit your winnings',
    fire: 'Fire',
    pickAlly: 'Select a teammate',
    pickEnemy: 'Select an enemy',
    confirmAction: 'Confirm',
    waiting: 'Waiting…',
    choosing: 'Choosing…',
    watchingReplay: 'Watching…',
    youWin: 'Victory',
    youLose: 'Defeat',
    sideWins: 'WIN',
    matchDraw: 'Draw',
    drawRefund: 'Coins refunded',
    botShort: 'Bot',
    copyMatchId: 'Copy match ID',
    matchIdCopied: 'Copied',
    roundN: 'Round {{round}}',
    autoStart: 'Auto-start in',
    grenadeNone: 'No',
    allies: 'Allies',
    enemies: 'Enemies',
    loadout: 'Loadout',
    toBattle: 'To battle',
    toBattleIn: 'To battle in {{sec}}s',
    statDamage: 'Damage',
    statRate: 'Rate',
    statCrit: 'Crit',
    statAccuracy: 'Accuracy',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'Rifle',
    weaponLmg: 'Machine gun',
    weaponAwpBlurb: 'Hits hard but rarely. High crit — either kills or misses.',
    weaponRifleBlurb: 'Balanced damage and rate of fire.',
    weaponLmgBlurb: 'Often but weak. Steadily racks up damage.',
    // Armor labels & blurbs
    armorNone: 'No armor',
    armorLight: 'Light vest',
    armorHeavy: 'Heavy vest',
    armorNoneBlurb: 'Maximum firepower, but fragile.',
    armorLightBlurb: 'Slightly cuts damage and crit.',
    armorHeavyBlurb: 'Heavily cuts peak damage and crit — counters AWP.',
    armorNumbers: '{{points}} armor points · bullet −30% dmg, crits pierce',
    // Gear in numbers (how-it-works info sheet)
    gearInfoOpen: 'How it works',
    gearInfoTitle: 'Gear in numbers',
    gearFragInfo: 'Up to {{max}} dmg to the target — armor won’t save; shrapnel clips one more enemy. [[defense|Defense]] takes ×1.35, [[maneuver|Maneuver]] ×0.8.',
    gearSmokeInfo: 'Smoke an ally: for {{rounds}} rounds he takes −{{mit}}% bullet damage. Knife and grenade ignore smoke.',
    gearFlashInfo: 'Blinds up to 3 enemies for {{rounds}} rounds: half accuracy, no crits.',
    gearMedkitInfo: 'Heals {{frac}}% of missing HP (at least {{floor}}). You don’t shoot this round and are open to the knife.',
    gearKnifeInfo: 'Free, every round. Target not shooting or braced in [[defense|Defense]] — {{dmg}} through armor, execute at ≤30% HP. Target in [[attack|Attack]] or [[maneuver|Maneuver]] — only {{weak}}, and you eat its point-blank fire.',
    // Result
    resultWin: 'Victory',
    resultTeamWin: 'Team won',
    resultDefeat: 'Defeat',
    resultWinSub: 'Your team won — you get a skin worth your share of the bank, split by contribution (MVP).',
    resultTeamWinSub: 'Your team won. Your fighter fell, but you still earned a skin worth your share by contribution (MVP).',
    resultDefeatSub: 'The team lost — better luck next round.',
    scoreboardTitle: 'Scoreboard',
    payout: 'Win',
    total: 'Total',
    again: 'Again',
    wonShort: 'Victory',
    viewLog: 'View log',
    roundLog: 'Log',
    roundLogTitle: 'Battle log',
    roundLogEmpty: 'First round is still playing',
    // Raffle tickets row — earned from this ranked match
    raffleTicketsTitle: '+{{n}} raffle tickets',
    raffleChipWin: 'Win +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Win at 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    // Winner drop reveal
    dropRevealTapHint: 'Tap to continue',
    dropYouTitle: 'Your drop',
    dropLabel: 'Drop',
    watch: 'Watch',
    // Live now (spectate)
    liveNowTitle: 'Live now',
    liveEmpty: 'No matches running right now',
    liveRoundBadge: 'Live · round {{n}}',
    spectate: 'Watch',
    matchOver: 'Match over',
    logMiss: 'miss',
    logMissEvade: 'miss — dodged',
    logMissBlind: 'miss — blinded',
    logReflect: 'reflected',
    logPunish: 'return fire',
    logLegend: '✦ crit pierces armor · ⚡ adrenaline',
    logKilledBy: 'killed by',
    colKills: 'K',
    canvasMiss: 'MISS',
    canvasMissEvade: 'DODGE',
    canvasMissBlind: 'BLIND',
    // History
    historyTitle: 'History',
    back: 'Back',
    matchDetailError: 'Couldn’t load this match. It may not exist — bot practice keeps no record.',
    historySubtitle: 'Your latest Rush Mid battles.',
    historyEmptyTitle: 'You have not played yet',
    historyEmptyDescription: 'Play your first Rush Mid battle — it will show up here.',
    win: 'Victory',
    defeat: 'Defeat',
    timeJustNow: 'just now',
    timeMinAgo: '{{min}} min ago',
    timeHoursAgo: '{{hours}} h ago',
    timeDaysAgo: '{{days}} d ago',
    // Rating
    ratingTab: 'Rating',
    yourRating: 'Your rating',
    earned: 'Earned',
    rating: 'Rating',
    played: 'Played',
    wins: 'Wins',
    winsCol: 'Wins',
    losses: 'Losses',
    lossesCol: 'Losses',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Win rate',
    player: 'Player',
    topPlayers: 'Top players',
    ratingUnratedTitle: 'No rating yet',
    ratingUnratedDescription: 'Play a match in this format to get a rating.',
    ratingEmptyTitle: 'No one here yet',
    ratingEmptyDescription: 'Be the first to play in this format.',
    // Raffle
    raffleTab: 'Raffle',
  },
  ru: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'Билет',
    format: 'Формат',
    side: 'Сторона',
    sideCt: 'Контр-террористы',
    sideT: 'Террористы',
    sideAny: 'Любая',
    skinLabel: 'Скин',
    practiceBots: 'С ботами',
    playWithBots: 'Играть с ботами · бесплатно',
    winRangeTitle: 'Скин за победу',
    skip: 'Пропустить',
    // Как играть (шторка правил + слайды первого входа)
    howtoTitle: 'Как играть',
    howtoNext: 'Дальше',
    howtoStart: 'Понятно, играем',
    howtoSkip: 'Пропустить',
    howtoSlide1Title: 'Пошаговый PvP',
    howtoSlide1Text:
      'Билет — твой взнос. Соперники — реальные игроки с таким же билетом. Победившая команда делит банк.',
    howtoSlide2Title: 'Закуп не решает',
    howtoSlide2Text:
      'Бюджет у всех одинаковый. Оружие задаёт стиль: AWP — редкий тяжёлый выстрел, пулемёт бьёт часто и ровно.',
    howtoSlide3Title: 'Читай соперника',
    howtoSlide3Text:
      'Каждый раунд выбираешь стойку. Смотри, что соперник делал в прошлом раунде — и контри его.',
    howtoSlide4Title: 'Скин — по вкладу',
    howtoSlide4Text:
      'Банк делится по урону и утилите, а выплачивается скином нужной стоимости. Даже если погиб — вклад засчитан. Банк набирается прокрутами всех билетов: победа приносит скин стоимостью минимум взнос +50%, потолок — ×5.',
    howtoTryBots: 'Сначала попробуй бесплатно — с ботами',
    howtoLoopTitle: 'Как проходит матч',
    howtoLoopStep1: 'Выбираешь билет, сторону и формат — это твой взнос.',
    howtoLoopStep2: 'Закуп: оружие, броня и утилита на равный бюджет.',
    howtoLoopStep3: 'Пошаговый бой: каждый раунд — стойка или действие. Цель выбираешь тапом.',
    howtoLoopStep4: 'Банк матча делится между победителями по вкладу и выплачивается скином.',
    howtoStancesTitle: 'Стойки',
    howtoRpsCaption: 'Стрелка показывает, кто кого бьёт',
    howtoStancesText:
      '[[defense|Защита]] отражает часть урона, [[maneuver|Манёвр]] сбивает точность врага, [[attack|Атака]] усиливает твой огонь.',
    howtoWeaponsTitle: 'Оружие',
    howtoWeaponAwp: 'AWP — всё или ничего: редкий выстрел, огромный крит.',
    howtoWeaponRifle: 'Винтовка — сбалансированная классика.',
    howtoWeaponLmg: 'Пулемёт — часто и ровно, без качелей крита.',
    howtoUtilityTitle: 'Утилита',
    howtoSmokeTargetNote: 'Дым прикрывает союзника — тапни своего, чтобы выбрать, кого закрыть.',
    howtoUtilTeamNote: 'Дым и флешка — только в командных режимах.',
    howtoMoneyTitle: 'Деньги',
    howtoMoney1: 'Бюджет закупа у всех равный — он решает стиль, а не силу.',
    howtoMoney2: 'Приз — скин, он делится по вкладу: урон + утилита. Смерть вклад не стирает.',
    howtoMoney3: 'Банк набирается прокрутами всех билетов: победа приносит скин стоимостью минимум взнос +50%, потолок — ×5.',
    howtoMoney4: 'Каждый билет — один прокрут банка: от половины до 2.5 билета за прокрут. Дороже билет — больше банк.',
    history: 'История',
    partyJoin: 'Войти по коду',
    partyJoinPlaceholder: 'Код пати',
    partyJoinAction: 'Войти',
    partyShare: 'Позвать друзей',
    partyKick: 'Убрать из пати',
    partyShareText: 'Залетай ко мне в пати SHOT — код {{code}}',
    partyErrNotFound: 'Пати не найдена — проверь код.',
    partyErrInGame: 'Пати уже в игре — сначала закончите её.',
    partyErrFull: 'Пати заполнена.',
    partyErrInMatch: 'Сначала закончи активный матч.',
    multiaccErr: 'Ты не можешь присоединиться сюда.',
    maintenanceErr: 'Идёт обновление игры — загляни через пару минут.',
    balanceErr: 'Не хватает монет на взнос — пополни баланс и возвращайся.',
    topUpBalance: 'Пополнить баланс',
    maintenanceBanner: 'Идёт обновление игры — матчи откроются через пару минут.',
    updateBanner: 'Вышло обновление — обнови, чтобы играть.',
    updateNow: 'Обновить',
    comingSoonBadge: 'Скоро',
    comingSoonHint: 'Режим ещё не открыт — следи за новостями.',
    partyLeaderTag: 'лидер',
    partyLeave: 'Выйти из пати',
    partyCodeLabel: 'Код пати',
    partyCopy: 'Копировать',
    partyCopied: 'Скопировано',
    partyCreatedBy: 'Создано {{name}}',
    partyLeaderBadge: 'Лидер',
    partyReadyYes: 'Готов',
    partyReadyNo: 'Не готов',
    partyWaitingOthers: 'Ожидает остальных игроков',
    partyConfirmReady: 'Подтверди готовность, чтобы начать игру.',
    partyImReady: 'Я готов',
    partyYou: 'Вы',
    partyShareBtn: 'Поделиться',
    partyReadyCount: 'Готово: {{n}} из {{m}}',
    // Modes
    mode1: '1 на 1',
    mode2: '2 на 2',
    mode5: '5 на 5',
    modeN: '{{size}} на {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: 'Игры',
    introCard: 'Rush Mid — это игровой аналог кейс-баттлов в стиле Counter-Strike: игроки заходят в матч с фиксированным билетом, сражаются между собой, и победитель получает скин, чья стоимость привязана к взносу.',
    openGamesTitle: 'Открытые игры',
    howToPlayLink: 'как играть',
    winUpToPrefix: 'за победу до',
    winUpToSuffix: '',
    waitingForPlayer: 'ждём игрока…',
    winRangeChip: 'за победу',
    notEnoughShort: 'не хватает',
    homeAllGames: 'все игры',
    createGame: 'Создать игру · ',
    createGameShort: 'Создать игру',
    gamesEmptyTitle: 'Здесь пока пусто',
    gamesEmpty: 'Открытых игр пока нет — создай первую',
    gamesBack: 'К списку игр',
    openGameTitle: 'Игра',
    joinSide: 'Сесть',
    confirmSitTitle: 'Сесть в игру',
    confirmSitMessage: 'Сесть в игру за {{amount}}?',
    confirmSitYes: 'Сесть',
    gameFull: 'Все места заняты',
    partyBadge: 'пати ×{{k}}',
    tabFighter: 'Боец',
    squadTitle: 'Пати',
    inviteFriends: 'Позвать друзей',
    leaderPicking: 'Лидер выбирает игру…',
    partyWontFit: 'пати ×{{k}} не влезет',
    graceLockedBadge: 'игра новичка · {{s}} с',
    graceLockedHint: 'Тут разминается новичок. Для всех откроется через {{s}} с.',
    partyFits: 'пати ×{{k}} влезет',
    wontFit: 'не влезет',
    memberBadge: 'В пати ×{{k}}',
    createSheetTitle: 'Создать игру',
    createSheetSubtitle: 'Выбери билет, формат и сторону',
    botFillIn: 'Боты добьют через {{s}} с',
    leaveGame: 'Выйти',
    youLabel: 'ты',
    gameInvite: 'Пригласить',
    gameShareText: 'Залетай ко мне в игру Rush Mid',
    gameShareButton: 'Играть',
    replayTitle: 'Реплей матча',
    shareReplay: 'Поделиться реплеем',
    replayShareText: 'Зацени этот матч в Rush Mid',
    replayShareButton: 'Смотреть реплей',
    gameGone: 'Эта игра уже началась или закрылась',
    tipLabel: 'Совет',
    preparing: 'Готовим бой…',
    loadingGame: 'Загружаем бой…',
    loading: 'Загрузка…',
    errorTitle: 'Ошибка RushMid',
    backToLobby: 'К играм',
    reloadScreen: 'Обновить экран',
    // Buy
    buyTitle: 'Закуп',
    remaining: 'Осталось',
    yourFighter: 'Твой боец',
    hp: 'HP',
    armorShort: 'бр.',
    weapon: 'Оружие',
    armor: 'Броня',
    grenade: 'Граната',
    grenadeTaken: 'Взята',
    medkit: 'Аптечка',
    accuracy: 'Точность',
    stance: 'Стойка',
    stanceCenter: 'Центр',
    stanceAttack: 'Атака',
    stanceDefense: 'Защита',
    stanceManeuver: 'Манёвр',
    knife: 'Нож',
    smoke: 'Дым',
    flash: 'Флешка',
    nadeSmoke: 'Дымовая',
    nadeFrag: 'Осколочная',
    logSmoke: 'дым',
    logAdrenaline: 'адреналин',
    adrenaline: 'адреналин',
    // Защита от AFK — метка на канвасе/скорборде у клеймённого игрока + плашка о пропуске
    afkBadge: 'AFK',
    afkWarn: 'Ещё один пропуск — останешься без выигрыша',
    fire: 'Огонь',
    pickAlly: 'Выбери своего',
    pickEnemy: 'Выбери врага',
    confirmAction: 'В бой',
    waiting: 'Ждём…',
    choosing: 'Выбирает…',
    watchingReplay: 'Смотрим…',
    youWin: 'Победа',
    youLose: 'Поражение',
    sideWins: 'ПОБЕДА',
    matchDraw: 'Ничья',
    drawRefund: 'Монеты возвращены',
    botShort: 'Бот',
    copyMatchId: 'Копировать ID матча',
    matchIdCopied: 'Скопировано',
    roundN: 'Раунд {{round}}',
    autoStart: 'Старт через',
    grenadeNone: 'Нет',
    allies: 'Союзники',
    enemies: 'Враги',
    loadout: 'Закуп',
    toBattle: 'В бой',
    toBattleIn: 'В бой через {{sec}} сек',
    statDamage: 'Урон',
    statRate: 'Темп',
    statCrit: 'Крит',
    statAccuracy: 'Точность',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'Автомат',
    weaponLmg: 'Пулемёт',
    weaponAwpBlurb: 'Бьёт сильно, но редко. Высокий крит — либо выносит, либо мажет.',
    weaponRifleBlurb: 'Сбалансированный урон и темп.',
    weaponLmgBlurb: 'Часто, но слабо. Ровно набивает урон.',
    // Armor labels & blurbs
    armorNone: 'Без брони',
    armorLight: 'Лёгкий жилет',
    armorHeavy: 'Тяжёлый жилет',
    armorNoneBlurb: 'Максимум огневой мощи, но хрупкий.',
    armorLightBlurb: 'Немного режет урон и крит.',
    armorHeavyBlurb: 'Сильно режет пиковый урон и крит — против AWP.',
    armorNumbers: '{{points}} очков брони · пуля −30% урона, крит пробивает',
    // Снаряжение в цифрах (шторка «как работает»)
    gearInfoOpen: 'Как работает?',
    gearInfoTitle: 'Снаряжение в цифрах',
    gearFragInfo: 'До {{max}} урона по цели — броня не спасает; осколок задевает ещё одного врага. По [[defense|Защите]] ×1.35, по [[maneuver|Манёвру]] ×0.8.',
    gearSmokeInfo: 'Дым на союзника: {{rounds}} раунда он получает −{{mit}}% урона от пуль. Нож и граната дым игнорируют.',
    gearFlashInfo: 'Слепит до 3 врагов на {{rounds}} раунда: точность вдвое ниже, крита нет.',
    gearMedkitInfo: 'Лечит {{frac}}% нехватки HP (минимум {{floor}}). В этот раунд ты не стреляешь и открыт для ножа.',
    gearKnifeInfo: 'Бесплатный, каждый раунд. Цель не стреляет или сидит в [[defense|Защите]] — {{dmg}} сквозь броню, при HP ≤ 30% — казнь. Цель в [[attack|Атаке]] или [[maneuver|Манёвре]] — всего {{weak}}, и ты ловишь её выстрел в упор.',
    // Result
    resultWin: 'Победа',
    resultTeamWin: 'Команда победила',
    resultDefeat: 'Поражение',
    resultWinSub: 'Команда победила — ты получаешь скин на стоимость своей доли банка, по вкладу (MVP).',
    resultTeamWinSub: 'Команда победила. Боец пал, но ты всё равно получил скин по своей доле — по вкладу (MVP).',
    resultDefeatSub: 'Команда проиграла — в следующий раз повезёт.',
    scoreboardTitle: 'Таблица',
    payout: 'Выигрыш',
    total: 'Итог',
    again: 'Ещё раз',
    wonShort: 'Победили',
    viewLog: 'Посмотреть лог',
    roundLog: 'Лог',
    roundLogTitle: 'Ход боя',
    roundLogEmpty: 'Первый раунд ещё идёт',
    // Raffle tickets row — earned from this ranked match
    raffleTicketsTitle: '+{{n}} билетов розыгрыша',
    raffleChipWin: 'Победа +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Трипл +{{n}}',
    raffleChipQuad: 'Квадра +{{n}}',
    raffleChipAce: 'Эйс +{{n}}',
    raffleChipOneHp: 'Победа с 1 HP +{{n}}',
    raffleChipClutch2: 'Клатч 1v2 +{{n}}',
    raffleChipClutch3: 'Клатч 1v3 +{{n}}',
    // Ревил дропа победителей
    dropRevealTapHint: 'Нажми, чтобы продолжить',
    dropYouTitle: 'Твой дроп',
    dropLabel: 'Дроп',
    watch: 'Посмотреть',
    // Идут сейчас (спектатор)
    liveNowTitle: 'Идут сейчас',
    liveEmpty: 'Сейчас никто не играет',
    liveRoundBadge: 'Идёт бой · раунд {{n}}',
    spectate: 'Смотреть',
    matchOver: 'Матч завершён',
    logMiss: 'мимо',
    logMissEvade: 'мимо — уворот',
    logMissBlind: 'мимо — ослеплён',
    logReflect: 'отражено',
    logPunish: 'ответный огонь',
    logLegend: '✦ крит пробивает броню · ⚡ адреналин',
    logKilledBy: 'убил',
    colKills: 'К',
    canvasMiss: 'МИМО',
    canvasMissEvade: 'УВОРОТ',
    canvasMissBlind: 'ОСЛЕП',
    // History
    historyTitle: 'История',
    back: 'Назад',
    matchDetailError: 'Не получилось загрузить матч. Возможно, записи нет — тренировка с ботами не сохраняется.',
    historySubtitle: 'Твои последние бои в Rush Mid.',
    historyEmptyTitle: 'Ты ещё не играл',
    historyEmptyDescription: 'Сыграй первый бой в Rush Mid — он появится здесь.',
    win: 'Победа',
    defeat: 'Поражение',
    timeJustNow: 'только что',
    timeMinAgo: '{{min}} мин назад',
    timeHoursAgo: '{{hours}} ч назад',
    timeDaysAgo: '{{days}} дн назад',
    // Rating
    ratingTab: 'Рейтинг',
    yourRating: 'Твой рейтинг',
    earned: 'Заработано',
    rating: 'Рейтинг',
    played: 'Сыграно',
    wins: 'Побед',
    winsCol: 'Победы',
    losses: 'Поражений',
    lossesCol: 'Поражения',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Винрейт',
    player: 'Игрок',
    topPlayers: 'Топ игроков',
    ratingUnratedTitle: 'Рейтинга пока нет',
    ratingUnratedDescription: 'Сыграй матч в этом формате, чтобы получить рейтинг.',
    ratingEmptyTitle: 'Здесь пока пусто',
    ratingEmptyDescription: 'Сыграй первым в этом формате.',
    // Raffle
    raffleTab: 'Розыгрыш',
  },
  uz: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'Bilet',
    format: 'Format',
    side: 'Tomon',
    sideCt: 'Kontr-terrorchilar',
    sideT: 'Terrorchilar',
    sideAny: 'Har qanday',
    skinLabel: 'Skin',
    practiceBots: "Botlar bilan",
    playWithBots: "Botlar bilan o‘ynash · bepul",
    winRangeTitle: "G'alaba uchun skin",
    skip: "O'tkazib yuborish",
    // Qanday o'ynash (qoidalar + birinchi kirish slaydlari)
    howtoTitle: "Qanday o'ynash",
    howtoNext: 'Keyingi',
    howtoStart: "Tushunarli, o'ynaymiz",
    howtoSkip: "O'tkazib yuborish",
    howtoSlide1Title: 'Navbatma-navbat PvP',
    howtoSlide1Text:
      "Bilet — sening to'loving. Raqiblar — xuddi shu biletli haqiqiy o'yinchilar. G'olib jamoa bankni bo'lishadi.",
    howtoSlide2Title: 'Xarid hal qilmaydi',
    howtoSlide2Text:
      "Hammada bir xil byudjet. Qurol uslubni belgilaydi: AWP — kam otadigan og'ir zarba, pulemyot tez va barqaror otadi.",
    howtoSlide3Title: "Raqibni o'qi",
    howtoSlide3Text:
      "Har raundda turish tanlaysan. Raqib o'tgan raundda nima qilganini ko'r — va unga qarshi o'yna.",
    howtoSlide4Title: "Skin — hissaga ko'ra",
    howtoSlide4Text:
      "Bank zarar va utilita bo'yicha bo'linadi, so'ng shu qiymatdagi skin sifatida beriladi. O'lsang ham hissang hisobda. Bank har biletning aylanishidan to'ladi: g'alaba kamida to'lov +50% qiymatidagi skin beradi, shift — ×5.",
    howtoTryBots: 'Avval bepul sinab ko‘r — botlar bilan',
    howtoLoopTitle: "Match qanday o'tadi",
    howtoLoopStep1: "Bilet, tomon va formatni tanlaysan — bu sening to'loving.",
    howtoLoopStep2: "Xarid: teng byudjetga qurol, zirh va utilita.",
    howtoLoopStep3: "Navbatma-navbat jang: har raund — turish yoki harakat. Nishonni tap bilan tanlaysan.",
    howtoLoopStep4: "Match banki g'oliblar orasida hissaga ko'ra bo'linadi va skin sifatida beriladi.",
    howtoStancesTitle: 'Turishlar',
    howtoRpsCaption: "Strelka kim kimni yengishini ko'rsatadi",
    howtoStancesText:
      "[[defense|Himoya]] zararning bir qismini qaytaradi, [[maneuver|Manyovr]] dushman aniqligini pasaytiradi, [[attack|Hujum]] otishingni kuchaytiradi.",
    howtoWeaponsTitle: 'Qurollar',
    howtoWeaponAwp: "AWP — hammasi yoki hech narsa: kam otadi, ulkan krit.",
    howtoWeaponRifle: 'Vintovka — muvozanatli klassika.',
    howtoWeaponLmg: "Pulemyot — tez va barqaror, krit tebranishlarisiz.",
    howtoUtilityTitle: 'Utilita',
    howtoSmokeTargetNote: "Tutun sherikni yopadi — kimni yopishni sherikni tap qilib tanlaysan.",
    howtoUtilTeamNote: "Tutun va flesh faqat jamoaviy rejimlarda bor.",
    howtoMoneyTitle: 'Pul',
    howtoMoney1: "Xarid byudjeti hammada teng — u uslubni belgilaydi, kuchni emas.",
    howtoMoney2: "Mukofot — skin, u hissaga ko'ra bo'linadi: zarar + utilita. O'lim hissani o'chirmaydi.",
    howtoMoney3: "Bank har biletning aylanishidan to'ladi: g'alaba kamida to'lov +50% qiymatidagi skin beradi, shift — ×5.",
    howtoMoney4: "Har bilet — bankning bitta aylanishi: har aylanishda yarmidan 2.5 biletgacha. Chipta qimmatroq — bank kattaroq.",
    history: 'Tarix',
    partyJoin: 'Kod bilan kirish',
    partyJoinPlaceholder: 'Parti kodi',
    partyJoinAction: 'Kirish',
    partyShare: "Do'stlarni chaqirish",
    partyKick: 'Partiyadan chiqarish',
    partyShareText: 'SHOT partimga qo‘shil — kod {{code}}',
    partyErrNotFound: 'Parti topilmadi — kodni tekshir.',
    partyErrInGame: 'Bu parti allaqachon oʻyinda — avval uni tugatinglar.',
    partyErrFull: 'Parti toʻlgan.',
    partyErrInMatch: 'Avval faol matchni tugat.',
    multiaccErr: 'Bu yerga qoʻshila olmaysan.',
    maintenanceErr: 'O‘yin yangilanmoqda — bir-ikki daqiqadan so‘ng qaytib kel.',
    balanceErr: 'To‘lov uchun tanga yetmaydi — balansni to‘ldirib qayt.',
    topUpBalance: 'Balansni to‘ldirish',
    maintenanceBanner: 'O‘yin yangilanmoqda — o‘yinlar bir-ikki daqiqada ochiladi.',
    updateBanner: 'Yangilanish chiqdi — o‘ynash uchun yangilang.',
    updateNow: 'Yangilash',
    comingSoonBadge: 'Tez orada',
    comingSoonHint: 'Rejim hali ochilmadi — kuzatib bor.',
    partyLeaderTag: 'lider',
    partyLeave: 'Partidan chiqish',
    partyCodeLabel: 'Parti kodi',
    partyCopy: 'Nusxa olish',
    partyCopied: 'Nusxa olindi',
    partyCreatedBy: '{{name}} yaratdi',
    partyLeaderBadge: 'Lider',
    partyReadyYes: 'Tayyor',
    partyReadyNo: 'Tayyor emas',
    partyWaitingOthers: "Qolgan o'yinchilar kutilyapti",
    partyConfirmReady: 'Boshlash uchun tayyorligingni tasdiqla.',
    partyImReady: 'Men tayyorman',
    partyYou: 'Siz',
    partyShareBtn: 'Ulashish',
    partyReadyCount: 'Tayyor: {{n}}/{{m}}',
    // Modes
    mode1: '1 ga 1',
    mode2: '2 ga 2',
    mode5: '5 ga 5',
    modeN: '{{size}} ga {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: "O'yinlar",
    introCard: 'Rush Mid — Counter-Strike uslubidagi keys-battl oʻyini: oʻyinchilar belgilangan bilet bilan matchga kiradi, bir-biri bilan jang qiladi va gʻalaba kirish narxiga bogʻliq qiymatdagi skin olib keladi.',
    openGamesTitle: 'Ochiq oʻyinlar',
    howToPlayLink: 'qanday oʻynaladi',
    winUpToPrefix: 'gʻalaba uchun',
    winUpToSuffix: 'gacha',
    waitingForPlayer: 'oʻyinchini kutamiz…',
    winRangeChip: 'gʻalaba uchun',
    notEnoughShort: 'yetmaydi:',
    homeAllGames: 'barcha oʻyinlar',
    createGame: 'Oʻyin yaratish · ',
    createGameShort: 'Oʻyin yaratish',
    gamesEmptyTitle: 'Hozircha boʻsh',
    gamesEmpty: 'Hali ochiq oʻyinlar yoʻq — birinchisini yarat',
    gamesBack: "Oʻyinlar roʻyxatiga",
    openGameTitle: "Oʻyin",
    joinSide: 'Oʻtirish',
    confirmSitTitle: 'Oʻyinga qoʻshilish',
    confirmSitMessage: '{{amount}} evaziga oʻtirasanmi?',
    confirmSitYes: 'Oʻtirish',
    gameFull: 'Barcha joylar band',
    partyBadge: 'parti ×{{k}}',
    tabFighter: 'Jangchi',
    squadTitle: 'Parti',
    inviteFriends: 'Do‘stlarni chaqirish',
    leaderPicking: 'Lider o‘yin tanlayapti…',
    partyWontFit: 'parti ×{{k}} sig‘maydi',
    graceLockedBadge: 'yangi o‘yinchi o‘yini · {{s}} s',
    graceLockedHint: 'Bu yerda yangi o‘yinchi qizdirmoqda. Hamma uchun {{s}} s dan keyin ochiladi.',
    partyFits: 'parti ×{{k}} sig‘adi',
    wontFit: 'sig‘maydi',
    memberBadge: 'Parti ×{{k}}',
    createSheetTitle: 'O‘yin yaratish',
    createSheetSubtitle: 'Bilet, format va tomonni tanla',
    botFillIn: 'Botlar {{s}} s dan keyin toʻldiradi',
    leaveGame: 'Chiqish',
    youLabel: 'sen',
    gameInvite: 'Taklif qilish',
    gameShareText: "Rush Mid oʻyinimga qoʻshil",
    gameShareButton: "O'ynash",
    replayTitle: 'Matn replayi',
    shareReplay: 'Replayni ulashish',
    replayShareText: 'Bu Rush Mid matchiga qara',
    replayShareButton: 'Replayni korish',
    gameGone: 'Bu oʻyin allaqachon boshlangan yoki yopilgan',
    tipLabel: 'Maslahat',
    preparing: 'Jang tayyorlanmoqda…',
    loadingGame: 'Jang yuklanmoqda…',
    loading: 'Yuklanmoqda…',
    errorTitle: 'RushMid xatosi',
    backToLobby: 'Oʻyinlarga qaytish',
    reloadScreen: 'Ekranni yangilash',
    // Buy
    buyTitle: 'Xarid',
    remaining: 'Qoldi',
    yourFighter: 'Sening jangching',
    hp: 'HP',
    armorShort: 'zirh',
    weapon: 'Qurol',
    armor: 'Zirh',
    grenade: 'Granata',
    grenadeTaken: 'Olindi',
    medkit: 'Aptechka',
    accuracy: 'Aniqlik',
    stance: 'Holat',
    stanceCenter: 'Markaz',
    stanceAttack: 'Hujum',
    stanceDefense: 'Himoya',
    stanceManeuver: 'Manyovr',
    knife: 'Pichoq',
    smoke: 'Tutun',
    flash: 'Flesh',
    nadeSmoke: 'Tutun',
    nadeFrag: 'Oskolka',
    logSmoke: 'tutun',
    logAdrenaline: 'adrenalin',
    adrenaline: 'adrenalin',
    // AFK himoyasi — chetlashtirilgan o'yinchining canvas/jadval belgisi + o'tkazib yuborish ogohlantiruvi
    afkBadge: 'AFK',
    afkWarn: 'Yana bir raundni o‘tkazib yuborsang — yutuqsiz qolasan',
    fire: 'Otish',
    pickAlly: 'Sherikni tanla',
    pickEnemy: 'Dushmanni tanla',
    confirmAction: 'Jangga',
    waiting: 'Kutilmoqda…',
    choosing: 'Tanlamoqda…',
    watchingReplay: "Ko'rilmoqda…",
    youWin: "G'alaba",
    youLose: "Mag'lubiyat",
    sideWins: 'YUTDI',
    matchDraw: 'Durang',
    drawRefund: 'Tangalar qaytarildi',
    botShort: 'Bot',
    copyMatchId: 'Match ID nusxa',
    matchIdCopied: 'Nusxa olindi',
    roundN: 'Raund {{round}}',
    autoStart: 'Avtostart',
    grenadeNone: "Yo'q",
    allies: 'Ittifoqchilar',
    enemies: 'Raqiblar',
    loadout: 'Jihoz',
    toBattle: 'Jangga',
    toBattleIn: '{{sec}}s dan keyin jangga',
    statDamage: 'Zarar',
    statRate: 'Temp',
    statCrit: 'Krit',
    statAccuracy: 'Aniqlik',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'Avtomat',
    weaponLmg: 'Pulemyot',
    weaponAwpBlurb: "Kuchli uradi, lekin kamdan-kam. Yuqori krit — yo o'ldiradi, yo tegmaydi.",
    weaponRifleBlurb: "Muvozanatli zarar va o'q otish tezligi.",
    weaponLmgBlurb: 'Tez-tez, lekin kuchsiz. Bir tekisda zarar toʻplaydi.',
    // Armor labels & blurbs
    armorNone: 'Zirhsiz',
    armorLight: 'Yengil jilet',
    armorHeavy: "Og'ir jilet",
    armorNoneBlurb: "Maksimal o't kuchi, lekin mo'rt.",
    armorLightBlurb: 'Zarar va kritni biroz kamaytiradi.',
    armorHeavyBlurb: "Cho'qqi zarar va kritni kuchli kamaytiradi — AWPga qarshi.",
    armorNumbers: '{{points}} bron ochkosi · o‘q −30% zarar, krit teshib o‘tadi',
    // Jihozlar raqamlarda (qanday ishlaydi sheet)
    gearInfoOpen: 'Qanday ishlaydi?',
    gearInfoTitle: 'Jihozlar raqamlarda',
    gearFragInfo: 'Nishonga {{max}} gacha zarar — bron qutqarmaydi; parcha yana bitta dushmanga tegadi. [[defense|Himoyaga]] ×1.35, [[maneuver|Manyovrga]] ×0.8.',
    gearSmokeInfo: 'Tutun sherikka: {{rounds}} raund davomida o‘qdan −{{mit}}% zarar oladi. Pichoq va granata tutunni pisand qilmaydi.',
    gearFlashInfo: '{{rounds}} raundga 3 tagacha dushmanni ko‘r qiladi: aniqlik ikki baravar past, krit yo‘q.',
    gearMedkitInfo: 'Yetishmayotgan HP ning {{frac}}% ini davolaydi (kamida {{floor}}). Bu raundda otmaysan va pichoqqa ochiqsan.',
    gearKnifeInfo: 'Bepul, har raund. Nishon otmayotgan yoki [[defense|Himoyada]] bo‘lsa — bron orqali {{dmg}}, HP ≤ 30% da qatl. [[attack|Hujum]] yoki [[maneuver|Manyovrda]] bo‘lsa — bor-yo‘g‘i {{weak}}, ustiga uning o‘qini yaqindan yeysan.',
    // Result
    resultWin: "G'alaba",
    resultTeamWin: "Jamoa g'alaba qozondi",
    resultDefeat: "Mag'lubiyat",
    resultWinSub: "Jamoa g'alaba qozondi — hissangga ko'ra ulushing qiymatidagi skinni olasan (MVP).",
    resultTeamWinSub: "Jamoa g'alaba qozondi. Jangching halok bo'ldi, lekin hissangga ko'ra skin ulushini oldingiz (MVP).",
    resultDefeatSub: "Jamoa yutqazdi — keyingi safar omad kulib boqadi.",
    scoreboardTitle: 'Jadval',
    payout: 'Yutuq',
    total: 'Yakun',
    again: 'Yana bir bor',
    wonShort: 'Yutdi',
    viewLog: 'Logni korish',
    roundLog: 'Log',
    roundLogTitle: 'Jang jarayoni',
    roundLogEmpty: 'Birinchi raund hali davom etmoqda',
    // Raffle tickets row — earned from this ranked match
    raffleTicketsTitle: '+{{n}} yutuq chiptasi',
    raffleChipWin: "G'alaba +{{n}}",
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: "1 HP bilan g'alaba +{{n}}",
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    // Yutuvchilar droping reveal
    dropRevealTapHint: 'Davom etish uchun bosing',
    dropYouTitle: 'Sening droping',
    dropLabel: 'Drop',
    watch: 'Korish',
    // Hozir ketmoqda (tomoshabin)
    liveNowTitle: 'Hozir ketmoqda',
    liveEmpty: 'Hozir hech kim oʻynamayapti',
    liveRoundBadge: 'Jang ketmoqda · raund {{n}}',
    spectate: 'Korish',
    matchOver: 'Match tugadi',
    logMiss: 'omon',
    logMissEvade: 'tegmadi — chap berdi',
    logMissBlind: 'tegmadi — ko‘r bo‘lgan',
    logReflect: 'qaytarildi',
    logPunish: 'javob o‘qi',
    logLegend: '✦ krit bronni teshadi · ⚡ adrenalin',
    logKilledBy: 'oldirdi',
    colKills: 'K',
    canvasMiss: 'TEGMADI',
    canvasMissEvade: 'CHAP BERDI',
    canvasMissBlind: 'KO‘R',
    // History
    historyTitle: 'Tarix',
    back: 'Orqaga',
    matchDetailError: 'Matchni yuklab bo‘lmadi. Yozuv yo‘q bo‘lishi mumkin — botlar bilan mashq saqlanmaydi.',
    historySubtitle: "Sening Rush Mid'dagi so'nggi janglaring.",
    historyEmptyTitle: "Sen hali o'ynamagansan",
    historyEmptyDescription: "Rush Mid'da birinchi jangingni o'yna — u shu yerda paydo bo'ladi.",
    win: "G'alaba",
    defeat: "Mag'lubiyat",
    timeJustNow: 'hozirgina',
    timeMinAgo: '{{min}} daq oldin',
    timeHoursAgo: '{{hours}} soat oldin',
    timeDaysAgo: '{{days}} kun oldin',
    // Rating
    ratingTab: 'Reyting',
    yourRating: 'Sening reytinging',
    earned: 'Ishlangan',
    rating: 'Reyting',
    played: "O'ynaldi",
    wins: "G'alabalar",
    winsCol: "G'alabalar",
    losses: "Mag'lubiyatlar",
    lossesCol: "Mag'lubiyatlar",
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: "G'alaba foizi",
    player: "O'yinchi",
    topPlayers: "Eng yaxshi o'yinchilar",
    ratingUnratedTitle: 'Hali reyting yo‘q',
    ratingUnratedDescription: 'Reyting olish uchun bu formatda o‘yna.',
    ratingEmptyTitle: 'Hali bo‘sh',
    ratingEmptyDescription: 'Bu formatda birinchi bo‘lib o‘yna.',
    // Raffle
    raffleTab: "Yutuq o'yini",
  },
});

/**
 * Playful CS-flavoured phrases cycled on the asset-loading screen (one swap every
 * couple of seconds) instead of a dull "loading…". Kept out of the typed
 * translations map because `t()` only returns strings; pick by `lang`.
 */
export const LOADING_PHRASES: Record<'en' | 'ru' | 'uz', string[]> = {
  ru: [
    'Накручиваем глушак…',
    'Перезаряжаемся…',
    'Закупаем гранаты…',
    'Точим ножи…',
    'Раскуриваем дымы…',
    'Калибруем сенсу…',
    'Чистим AWP…',
    'Учим раскидки…',
    'Заходим на мид…',
    'Греем наушники…',
    'Зовём тиммейтов…',
    'Разминаем пальцы…',
  ],
  en: [
    'Screwing on the silencer…',
    'Reloading…',
    'Buying grenades…',
    'Sharpening knives…',
    'Lighting up smokes…',
    'Calibrating sensitivity…',
    'Cleaning the AWP…',
    'Learning nade lineups…',
    'Rushing mid…',
    'Warming up the headset…',
    'Calling the teammates…',
    'Stretching fingers…',
  ],
  uz: [
    'Glushitelni burab qo‘yyapmiz…',
    'Qayta o‘qlanmoqdamiz…',
    'Granatalar olyapmiz…',
    'Pichoqlarni charxlaymiz…',
    'Tutun granatalarini yoqamiz…',
    'Sezgirlikni sozlaymiz…',
    'AWP ni tozalaymiz…',
    'Raskidkalarni o‘rganamiz…',
    'Midga kiramiz…',
    'Quloqchinni isitamiz…',
    'Jamoadoshlarni chaqiramiz…',
    'Barmoqlarni qizdiramiz…',
  ],
};

/**
 * Real gameplay tips cycled on the matchmaking-search screen (one swap every few
 * seconds). They teach the actual mechanics (stance RPS, knife reads, defensive
 * smoke, enemy flash, grenade armor-break, comeback medkit, armor, economy).
 * Kept out of the typed map for the same reason as LOADING_PHRASES — pick by `lang`.
 */
export const SEARCH_TIPS: Record<'en' | 'ru' | 'uz', string[]> = {
  ru: [
    'Стойки — это камень-ножницы-бумага: Атака бьёт Манёвр, Манёвр бьёт Защиту, Защита бьёт Атаку.',
    'Нож рвёт того, кто защищается, лечится или ставит дым. Но если полезешь на стреляющего — он тебя накажет.',
    'Дым — прикрытие своего: накрой раненого союзника, и два раунда по нему проходит вдвое меньше урона, а он сам продолжает стрелять.',
    'Флешка — наоборот, по врагу: слепит цель и её соседей, два раунда они мажут и не выбивают крит. Кидай, пока враги в полном составе.',
    'Дым не спасает от гранаты и ножа: задымлённого союзника всё равно достанут взрывом или вплотную.',
    'Граната пробивает броню в эпицентре и особенно больно бьёт того, кто встал в глухую Защиту — отсидеться не выйдет. А Манёвр, наоборот, уводит от части взрыва.',
    'Лечишься — в этот раунд не стреляешь и открыт. И чем сильнее ранен, тем больше вернёт аптечка: это отыгрыш из ямы, а не сустейн.',
    'Меньшинство не приговор: каждый боец отстающей команды получает на раунд адреналин-щит (янтарная полоска) — чем больше разрыв, тем толще. Дави числом, но добивай быстро.',
    'Не фокусь толпой одного: чем больше врагов бьёт одну отстающую цель, тем меньше проходит урона (синие цифры — удар погашен). Размазывай огонь по целям.',
    'Защита отражает часть урона обратно атакующему, но сам ты бьёшь слабее.',
    'Манёвр сбивает вражескую точность — хорош против того, кто встал в глухую оборону.',
    'Броня держит поток мелких пуль (пулемёт/автомат вязнут), но снайперский крит её пробивает — от AWP броня не спасёт.',
    'У всех одинаковый бюджет: закупка решает стиль, а не силу. Криты решают.',
    'Не угадывай вслепую — смотри, что соперник делал в прошлом раунде, и читай его.',
    'Тот, кто стреляет, держит одну цель, пока она жива — убей её, чтобы сбить ему фокус.',
    'Приз в победившей команде делят по вкладу — считается не только урон, но и польза: дым, флешка, аптечка. Чем полезнее ты команде, тем больше доля.',
    'Дым и флешка — только в командных режимах: в 1 на 1 их нет.',
    'Нож бесплатный и доступен каждый раунд — это всегда запасной план.',
    'Граната задевает и соседа цели — кидай в скопление врагов.',
    'AWP — редкий тяжёлый выстрел: крит пробивает броню и наказывает отсидку. Но медленный — в упор его переливают из пулемёта/автомата.',
    'Пулемёт бьёт часто и слабо — ровно набивает урон без качелей крита.',
    'Каждый билет добавляет в банк случайную сумму — от половины до 2.5 билета. Победители делят банк по вкладу и получают скин: победа приносит скин стоимостью минимум взнос +50%, потолок — ×5.',
    'Нож казнит раненого: пассивная цель с низким HP умирает от удара мгновенно. Не отсиживайся в Защите на последнем издыхании.',
    'Не выбрал действие до конца таймера — сервер сходит за тебя выстрелом в Атаке. Лучше выбери сам.',
    'Обе команды выбиты одновременно — ничья: взнос вернётся полностью.',
    'Из живого боя выйти нельзя — за отсутствующего ходит автопилот, а взнос и рейтинг решает исход матча. Вернёшься — попадёшь прямо в бой. Автопилот бьёт вслепую, лучше играй сам.',
    'Победы и поражения двигают твой рейтинг (ничья не меняет) — топ во вкладке «Рейтинг». Сид боя раскрывается после матча: любой раунд можно проверить в реплее.',
    'Цель выбираешь сам: тапни врага — весь огонь пойдёт по нему; тапни своего — дым полетит прикрывать его.',
  ],
  en: [
    'Stances are rock-paper-scissors: Attack beats Maneuver, Maneuver beats Defense, Defense beats Attack.',
    'The knife shreds anyone defending, healing or smoking. Charge a shooter, though, and they punish you.',
    'Smoke covers your own: shield a hurt teammate and for two rounds they take only half the gun damage — while they keep shooting.',
    'Flash is the opposite — on the enemy: it blinds the target and its neighbours, so for two rounds they miss and can’t crit. Throw it while the enemy is at full strength.',
    'Smoke won’t save you from a grenade or a knife — a smoked teammate still gets caught by the blast or up close.',
    'A grenade punches through armor at the centre and hits a turtling defender extra hard — you can’t just sit it out. Maneuver, on the other hand, ducks part of the blast.',
    'Healing means you don’t shoot that round and you’re exposed. The more hurt you are, the more the medkit gives back — a comeback tool, not steady sustain.',
    'Being outnumbered isn’t a death sentence: every trailing fighter gets a round-long adrenaline shield (the amber bar) — the bigger the gap, the thicker. Push your numbers, but finish fast.',
    'Don’t dogpile one target: the more enemies focus the same fighter, the less each shot lands (blue numbers — the hit is braced). Spread your fire across targets.',
    'Defense reflects part of the damage back at the attacker, but your own damage is weaker.',
    'Maneuver lowers the enemy’s accuracy — great against someone turtling in Defense.',
    'Armor eats a stream of small bullets (LMG/rifle bog down in it), but a sniper crit punches through — armor won’t save you from the AWP.',
    'Everyone gets the same budget: your buy sets the style, not the power. Crits decide.',
    'Don’t guess blind — watch what your opponent did last round and read them.',
    'Shooters lock onto one target and stick to it until it dies — kill their target to break their focus.',
    'The winning team splits the prize by contribution — damage AND utility: smokes, flashes and medkits all count. The more useful you are, the bigger your cut.',
    'Smoke and flash only exist in team modes — there’s none in 1v1.',
    'The knife is free and available every round — it’s always a backup plan.',
    'A grenade also clips an ally next to the target — throw it into a cluster.',
    'The AWP is a rare heavy shot: its crit punches through armor and punishes turtling. But it’s slow — up close an LMG/rifle out-guns it.',
    'The machine gun fires often and weak — steady damage with no crit swings.',
    'Every ticket adds a random amount to the bank — from half up to 2.5× the ticket. The winners split the bank by contribution and get paid in a skin: a win is worth at least your entry +50%, the ceiling is ×5.',
    'The knife executes the wounded: a passive target on low HP dies to one strike. Don’t turtle in Defense on your last breath.',
    'Pick nothing before the timer runs out and the server shoots for you in Attack. Better pick yourself.',
    'Both teams wiped in the same instant — a draw: your entry comes back in full.',
    'You can’t quit a live fight — an absent player runs on autopilot, and your entry and rating settle with the match result. Come back and you drop straight into the battle. Autopilot shoots blind — better play it yourself.',
    'Wins and losses move your rating (a draw doesn’t) — see the top in the Rating tab. The match seed is revealed afterwards: any round can be verified in the replay.',
    'You pick the target: tap an enemy and your fire goes there; tap a teammate and your smoke covers them.',
  ],
  uz: [
    'Turishlar — tosh-qaychi-qog‘oz: Hujum Manyovrni, Manyovr Himoyani, Himoya Hujumni yengadi.',
    'Pichoq himoyalanayotgan, davolanayotgan yoki tutun qo‘yayotganni yorib tashlaydi. Otayotganga yugursang — jazolaydi.',
    'Tutun — o‘zingnikini yopadi: yarador sherigingni yop, ikki raund unga o‘q zarari yarmi tegadi, o‘zi esa otaveradi.',
    'Flesh — aksincha, dushmanga: nishon va yonidagilarni ko‘r qiladi, ikki raund ular xato otadi va krit chiqarolmaydi. Dushman to‘liq kuchda turganda tashla.',
    'Tutun granata va pichoqdan saqlamaydi — tutundagi sherikni baribir portlash yoki yaqindan oladi.',
    'Granata markazda zirhni teshadi va qattiq himoyaga o‘tganni ayniqsa og‘riq uradi — o‘tirib chiqib bo‘lmaydi. Manyovr esa portlashning bir qismidan qochiradi.',
    'Davolansang — o‘sha raund otmaysan va ochiqsan. Qanchalik yarador bo‘lsang, aptechka shuncha ko‘p qaytaradi — bu chuqurdan chiqish vositasi, doimiy tiklanish emas.',
    'Ozchilik mahkum emas: orqada qolgan har bir jangchi raundga adrenalin-qalqon oladi (sariq chiziq) — farq qancha katta bo‘lsa, qalqon shuncha qalin. Son bilan bos, lekin tez tugat.',
    'Bittaga to‘planma: bitta nishonni qancha ko‘p dushman fokuslasa, har biri shuncha kam uradi (ko‘k raqamlar — zarba yumshatildi). Olovni nishonlarga taqsimla.',
    'Himoya zararning bir qismini hujumchiga qaytaradi, lekin o‘zing zaifroq urasan.',
    'Manyovr raqib aniqligini pasaytiradi — qattiq himoyaga o‘tganga qarshi zo‘r.',
    'Zirh mayda o‘qlar oqimini ushlaydi (pulemyot/avtomat unda tiqilib qoladi), lekin snayper kriti uni teshadi — AWPdan zirh saqlamaydi.',
    'Hammada bir xil byudjet: xarid uslubni belgilaydi, kuchni emas. Kritlar hal qiladi.',
    'Ko‘r-ko‘rona taxmin qilma — raqib o‘tgan raundda nima qilganini ko‘r va o‘qib ol.',
    'Otuvchilar bitta nishonni o‘lguncha ushlab otadi — fokusni buzish uchun ularning nishonini yo‘q qil.',
    'G‘olib jamoa mukofotni hissaga ko‘ra bo‘lishadi — faqat zarar emas, foyda ham hisoblanadi: tutun, flesh, aptechka. Jamoaga qancha foydali bo‘lsang, ulushing shuncha katta.',
    'Tutun va flesh faqat jamoaviy rejimlarda bor — 1ga1da yo‘q.',
    'Pichoq bepul va har raundda mavjud — bu doim zaxira reja.',
    'Granata nishon yonidagi sherikni ham ilintiradi — to‘plangan joyga tashla.',
    'AWP — kam otadigan og‘ir zarba: kriti zirhni teshadi va o‘tirishni jazolaydi. Lekin sekin — yaqindan uni pulemyot/avtomat o‘tkazib yuboradi.',
    'Pulemyot tez va kuchsiz otadi — krit tebranishlarisiz barqaror zarar.',
    'Har bilet bankka tasodifiy summa qo‘shadi — yarmidan 2.5 biletgacha. G‘oliblar bankni hissaga ko‘ra bo‘lishib skin sifatida olishadi: g‘alaba kamida to‘lov +50% qiymatidagi skin beradi, shift — ×5.',
    'Pichoq yaradorni qatl qiladi: HP kam passiv nishon bir zarbadan o‘ladi. Oxirgi nafasda Himoyada o‘tirma.',
    'Taymer tugaguncha tanlamasang — server sen uchun Hujumda otadi. Yaxshisi o‘zing tanla.',
    'Ikkala jamoa bir vaqtda qulasa — durang: to‘lov to‘liq qaytadi.',
    'Jonli jangdan chiqib bo‘lmaydi — yo‘q o‘yinchi o‘rniga avtopilot yuradi, to‘lov va reyting o‘yin natijasi bilan hal bo‘ladi. Qaytsang — to‘g‘ri jangga tushasan. Avtopilot ko‘r otadi — yaxshisi o‘zing o‘yna.',
    'G‘alaba va mag‘lubiyat reytingni o‘zgartiradi (durang — yo‘q) — top «Reyting» bo‘limida. O‘yin seedi o‘yindan keyin ochiladi: istalgan raundni replayda tekshirsa bo‘ladi.',
    'Nishonni o‘zing tanlaysan: dushmanni tap qil — butun olov unga ketadi; sherigingni tap qil — tutun uni yopadi.',
  ],
};
